async function readAsDataURL(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const readerData = reader.result;
            if (readerData === null) {
                resolve({
                    file,
                    data: "",
                    dataWithoutMeta: "",
                    mediaType: ""
                });
                return;
            }
            const data = typeof readerData === "string" ? readerData : readerData.toString();
            const dataURLDescription = getDataURLDescription(data);
            if (dataURLDescription === undefined) {
                resolve({
                    file,
                    data: "",
                    dataWithoutMeta: "",
                    mediaType: ""
                });
                return;
            }
            resolve({
                file,
                ...dataURLDescription
            });
        };
        reader.onerror = (error)=>{
            reject(error);
        };
        reader.readAsDataURL(file);
    });
}
const getMediaType = (rawData)=>{
    const mediaTypeMatch = rawData.match(/data:(.+);base64,/);
    if (!mediaTypeMatch || !mediaTypeMatch.length) {
        return undefined;
    }
    return mediaTypeMatch[1];
};
const removeDataURLMeta = (dataURL, mediaType)=>{
    return dataURL.substring(mediaType.length + 13, dataURL.length);
};
const getDataURLDescription = (dataURL)=>{
    const mediaType = getMediaType(dataURL);
    if (!mediaType) {
        return undefined;
    }
    return {
        data: dataURL,
        dataWithoutMeta: removeDataURLMeta(dataURL, mediaType),
        mediaType
    };
};
const AUDIO_FILE_TYPE = [
    "audio/mpeg",
    "audio/webm"
];
const IMAGE_FILE_TYPE = [
    "image/png",
    "image/jpeg",
    "image/jpg"
];
const VIDEO_FILE_TYPE = [
    "video/mp4",
    "video/quicktime",
    "video/webm"
];

export { AUDIO_FILE_TYPE, IMAGE_FILE_TYPE, VIDEO_FILE_TYPE, getDataURLDescription, getMediaType, readAsDataURL, removeDataURLMeta };
